/* eslint-disable jsx-a11y/aria-role */
/* eslint-disable no-cond-assign */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { CHANNEL_TYPES } from '@bingads-webui-campaign/recommendation-core';
import * as adDisplayUrlService from '@bingads-webui-campaign-legacy/crud-ad/service/displayUrl';
import { combineText } from '@bingads-webui-campaign-legacy/crud-ad/viewmodel/adsPreview/expandedTextAd';
import * as schemaCampaignVnext from '@bingads-webui-component-legacy/schema-campaign-vnext/index';

export class RecommendationsDetails extends React.PureComponent {
  static propTypes = {
    scope: PropTypes.shape({
      accountId: PropTypes.number.isRequired,
      adGroupId: PropTypes.number,
      campaignId: PropTypes.number,
      customerId: PropTypes.number.isRequired,
      levelAt: PropTypes.string.isRequired,
    }).isRequired,
    campaignType: PropTypes.number,
    source: PropTypes.string,
    setData: PropTypes.func.isRequired,
    prevCategoryType: PropTypes.string,
    navigateBack: PropTypes.func.isRequired,
    type: PropTypes.string.isRequired,
    currency: PropTypes.string.isRequired,
    deps: PropTypes.shape({
      i18n: PropTypes.PropTypes.shape({
        getString: PropTypes.func.isRequired,
      }).isRequired,
      s$i18n: PropTypes.PropTypes.shape({
        value: PropTypes.func,
      }),
      appConfig: PropTypes.objectOf(PropTypes.any).isRequired,
      permissions: PropTypes.object.isRequired,
      odata: PropTypes.PropTypes.shape({
        get: PropTypes.func.isRequired,
        patch: PropTypes.func.isRequired,
      }).isRequired,
      adDisplayUrlService: PropTypes.object,
      schemaCampaignVnext: PropTypes.object,
      combineText: PropTypes.func,
    }).isRequired,
    dataService: PropTypes.shape({
      getSummary: PropTypes.func.isRequired,
      track: PropTypes.func.isRequired,
    }).isRequired,
    showAlertHandler: PropTypes.func.isRequired,
    reload: PropTypes.func.isRequired,
    guid: PropTypes.string.isRequired, // for adinsight view event log in aria
    downloadService: PropTypes.objectOf(PropTypes.any),
    viewDetails: PropTypes.func.isRequired,
    viewBAADetails: PropTypes.func,
    context: PropTypes.shape({
      Source: PropTypes.string,
      Level: PropTypes.string,
      Category: PropTypes.string,
    }),
    data: PropTypes.objectOf(PropTypes.any),
    // eslint-disable-next-line react/forbid-prop-types, react/require-default-props
    perfMarker: PropTypes.shape({
      willInit: PropTypes.func.isRequired,
      willFetchData: PropTypes.func.isRequired,
      willRender: PropTypes.func.isRequired,
      done: PropTypes.func.isRequired,
      createChild: PropTypes.func.isRequired,
    }),
    isMCC: PropTypes.bool,
    readOnly: PropTypes.bool,
    showAsyncApplyModal: PropTypes.func,
    closeAsyncApplyModal: PropTypes.func,
    showApplyConfirmModal: PropTypes.func,
    overallOptimizationScoreBar: PropTypes.shape({
      Gained: PropTypes.number,
      Dismissed: PropTypes.number,
      Available: PropTypes.number,
    }),
    isOptimizationScoreOn: PropTypes.bool,
    isAutoApplyRecommendationEnabled: PropTypes.bool,
    serverContext: PropTypes.shape({}),
    isDismissedCategory: PropTypes.bool,
  };

  static defaultProps = {
    campaignType: null,
    source: null,
    prevCategoryType: null,
    downloadService: null,
    context: null,
    data: null,
    perfMarker: {
      willInit: _.noop,
      willFetchData: _.noop,
      willRender: _.noop,
      done: _.noop,
      createChild: () => this,
    },
    readOnly: false,
    viewBAADetails: _.noop,
    isMCC: false,
    showAsyncApplyModal: _.noop,
    closeAsyncApplyModal: _.noop,
    showApplyConfirmModal: _.noop,
    overallOptimizationScoreBar: null,
    isOptimizationScoreOn: false,
    isAutoApplyRecommendationEnabled: false,
    serverContext: {},
    isDismissedCategory: false,
  }

  constructor(props) {
    super(props);
    this.perfMarker = props.perfMarker.createChild('RecommendationDetailsGridOverall');
    if (_.isFunction(this.perfMarker.willInit)) {
      this.perfMarker.willInit();
    }
    this.hasSetData = false;
    this.recommendationsDetailsHeaderLazy = null;
    this.recommendationsGridContainerLazy = null;
    this.initLegacyDeps();
  }

  state = {
    showDetailsHeader: true,
    loaded: false,
  }

  componentDidMount = () => {
    if (_.isFunction(this.perfMarker.willFetchData)) {
      this.perfMarker.willFetchData();
    }
  };

  setDataFromDetails = () => {
    this.hasSetData = true;
  }

  initLegacyDeps = () => {
    if (_.isUndefined(this.props.deps.adDisplayUrlService)) {
      this.props.deps.adDisplayUrlService = adDisplayUrlService;
    }
    if (_.isUndefined(this.props.deps.schemaCampaignVnext)) {
      this.props.deps.schemaCampaignVnext = schemaCampaignVnext;
    }
    if (_.isUndefined(this.props.deps.combineText)) {
      this.props.deps.combineText = combineText;
    }
  }

  receiveMessage = (event, data = {}) => {
    const showInfoEvent = /showInfo:(.*)/g;
    const showWarningEvent = /showWarning:(.*)/g;
    let match;

    if (event === 'loaded') {
      if (!this.state.loaded) {
        if (_.isFunction(this.perfMarker.done)) {
          this.perfMarker.done();
        }
      }
      this.setState({ loaded: true });
    } else if (event === 'individualView') {
      this.setState({ showDetailsHeader: false });
    } else if (event === 'allView') {
      this.setState({ showDetailsHeader: true });
    } else if (event === 'back') {
      this.props.navigateBack();
    } else if (event === 'refreshSummary') {
      this.props.reload({ isFromApplyOrDismiss: data.isFromApplyOrDismiss });
    } else if ((match = showInfoEvent.exec(event)) !== null) {
      if (match.length === 2) {
        this.props.showAlertHandler({
          message: match[1],
          level: 'Info',
          dismissible: true,
        });
      }
      this.props.reload();
    } else if ((match = showWarningEvent.exec(event)) !== null) {
      if (match.length === 2) {
        this.props.showAlertHandler({
          message: match[1],
          level: 'Warning',
          dismissible: true,
        });
      }
      this.props.reload();
    } else if (event === 'updateScope') {
      if (this.props.isMCC) {
        this.props.viewBAADetails(this.props.type, data, this.props.prevCategoryType)();
      } else {
        this.props.viewDetails(this.props.type, data)();
      }
    } else if (event === 'showAsyncApplyModal') {
      this.props.showAsyncApplyModal(data);
    } else if (event === 'closeAsyncApplyModal') {
      this.props.closeAsyncApplyModal();
    } else if (event === 'showApplyConfirmModal') {
      this.props.showApplyConfirmModal(data);
    }
  }

  render() {
    if (_.isFunction(this.perfMarker.willRender)) {
      this.perfMarker.willRender();
    }

    const hasData = (this.props.data && this.props.data[this.props.type]) || {};
    if (this.hasSetData && _.isEmpty(hasData)) {
      this.props.navigateBack();
      return null;
    }

    if (_.isNull(this.recommendationsDetailsHeaderLazy)) {
      this.recommendationsDetailsHeaderLazy = React.lazy(() => import(/* webpackMode: 'eager' */ './recommendations-details-header').then(({ RecommendationsDetailsHeader }) => ({ default: RecommendationsDetailsHeader })));
    }
    const ReRecommendationsDetailsHeaderLazy = this.recommendationsDetailsHeaderLazy;

    const topOfGridContent = !_.isEmpty(hasData) ? (
      <ReRecommendationsDetailsHeaderLazy
        {...this.props}
        channel={this.props.isMCC ? CHANNEL_TYPES.MCCRECOMMENDATION : CHANNEL_TYPES.RECOMMENDATION}
        visible={this.state.showDetailsHeader}
      />
    ) : null;

    let recommendationsGridContainer = null;
    if (_.isNull(this.recommendationsGridContainerLazy)) {
      this.recommendationsGridContainerLazy = React.lazy(() => import(/* webpackMode: 'eager' */ '@bingads-webui-campaign-react/recommendation-grid-container').then(({ RecommendationsGridContainer }) => ({ default: RecommendationsGridContainer })));
    }
    const RecommendationsGridContainerLazy = this.recommendationsGridContainerLazy;
    recommendationsGridContainer = (<RecommendationsGridContainerLazy
      {...this.props}
      i18n={this.props.deps.i18n}
      s$i18n={this.props.deps.s$i18n}
      recommendationType={this.props.type}
      campaignType={this.props.campaignType}
      recommendationService={this.props.dataService}
      category={this.prevCategoryType}
      onEvent={this.receiveMessage}
      version={hasData.version}
      perfMarker={this.props.perfMarker}
      primaryEstimate={hasData.estimates && hasData.estimates.primaryEstimate}
      topOfGridContent={topOfGridContent}
      readOnly={this.props.readOnly}
      recommendationTypesAvailable={Object.keys(this.props.data)}
      setDataFromDetails={this.setDataFromDetails}
      context={_.extend(
        {},
        this.props.context,
        { ScoreUpLift: hasData.optimizationScore }
      )}
      serverContext={this.props.serverContext}
    />);

    return (
      <div className="details-view-container">
        <React.Suspense fallback={null}>
          {recommendationsGridContainer}
        </React.Suspense>
      </div>
    );
  }
}
